import * as types from "../types/systemBranches"

const initialState = []

const systemBranchesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SYSTEM_BRANCHES:
      return [...action.branches]
    default: return state
  }
}

export default systemBranchesReducer